<template>
  <div class="complain-submit" id="myBtn" :class="{ nav_select: navdata }">
    <!-- <div class="title">
			<van-nav-bar title="投诉">
				<van-icon name="arrow-left" slot="left" @click="Back()" />
			</van-nav-bar>
		</div> -->
    <div class="content" ref="comPage">
      <div class="form-item">
        <div class="form-label">投诉类别<span>(必填)</span></div>
        <div class="form-choose">
          <p class="choosetype">
            <!-- <span v-if="!chooseNote">请选择投诉类别</span> -->
            <span class="chooseNote">{{ this.choosetext }}</span>
            <!-- <van-icon name="arrow" v-if="!showType" />
						<van-icon name="arrow-down" v-if="showType" /> -->
          </p>
        </div>
      </div>

      <van-tree-select v-if="showType" height="auto" :items="items" :active-id.sync="activeId" :main-active-index.sync="activeIndex" @itemclick="onItemClick" />

      <!-- 投诉事件发生地 -->
      <div class="form-item greenway" ref="greenPage">
        <div class="form-label">投诉事件发生地<span>(必填)</span></div>
        <div class="form-choose">
          <p class="choosetype" @click="showArea()">
            <span v-if="!areaNote">请选择投诉事件发生地</span>
            <span v-if="areaNote" class="chooseNote">{{ this.name }}</span>
            <van-icon name="arrow" v-if="!areaType" />
            <van-icon name="arrow-down" v-if="areaType" />
          </p>
        </div>
      </div>
      <van-action-sheet v-model="show" :actions="option1" @select="onSelect" @click-overlay="clickOverlay" :round="ifRound" />
      <div class="form-item">
        <div class="form-label">投诉对象<span>(必填)</span></div>
        <div class="form-choose">
          <p class="choosetype">
            <span class="chooseNote">
              {{ this.respondent }}
            </span>
          </p>
        </div>
      </div>
      <van-cell-group>
        <van-field v-model="complaintReson" class="reason" rows="5" autosize label="投诉原因" type="textarea" placeholder="请填写投诉原因" maxlength="50" show-word-limit />
        <span>(必填)</span>
      </van-cell-group>

      <div class="up-img">
        <p>上传图片<span>(最多上传10张)</span></p>
        <div class="fb-btn">
          <div class="icon-img">
            <van-uploader :multiple="true" :after-read="afterRead" :disabled="picDisabled" v-model="fileList" @delete="onDelete" :max-count="10">
            </van-uploader>
          </div>
          <van-loading size="24px" v-if="loadingImg">上传中...</van-loading>
        </div>
      </div>

      <div class="form-item">
        <div class="form-label">投诉人</div>
        <div class="form-choose">
          <van-field placeholder="请填写投诉人" @blur="InputBlur()" v-model="complainant" />
        </div>
      </div>
      <div class="form-item">
        <div class="form-label">联系电话</div>
        <div class="form-choose">
          <van-field placeholder="" v-model="phone" />
        </div>
      </div>
      <div class="subbutton">
        <van-button slot="button" size="small" class="submit" @click="onSubmit()" :loading="loadingbutton" :loading-text="loadingtext">
          <p>提交</p>
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import qs from 'qs';
import { Dialog } from 'vant';
export default {
  data() {
    return {
      loadingImg: false,
      activeId: 1,
      activeIndex: 0,
      items: [],
      respondent: '', //投诉对象
      complaintReson: '', //投诉原因
      complainant: localStorage.getItem('userName'), //投诉人
      phone: localStorage.getItem('mobile'), //投诉人联系电话
      uid: '', //投诉人的id
      type: '3', //一级分类
      category: '9', //二级分类
      showType: false,
      choosetext: '其它', //选中二级菜单后展示的内容
      chooseNote: false,
      picDisabled: false,
      fileList: [], // 图片上传临时存放数组
      gallerys: [], // 图片上传服务器返回的数组
      picDelete: require('../../assets/iconImage/icon_delate@2x.png'),
      latitude: '',
      range: '100000',
      longitude: '',
      value: '',
      option1: [],
      optionTitle: '请选择投诉事件发生地',
      loadingbutton: false,
      loadingtext: '加载中',
      navdata: false,

      show: false,
      // areaArray: [
      //   { name: '选项',value:1 },
      //   { name: '选项' },
      //   { name: '选项' }
      // ],
      areaType: false,
      areatext: '', //选中二级菜单后展示的内容
      areaNote: false,
      name: '',
      ifRound: false,
      //areaArray:[],
    };
  },

  created() {
    this.getComplainttype();
    if (Object.keys(this.$route.query).length !== 0) {
      if (this.$route.query.item !== '') {
        // this.type = this.$route.query.item.complainType;
        // this.category = this.$route.query.item.complainCatagory;
        // this.choosetext = this.$route.query.item.complainCatagoryName;
        // this.complaintReson = this.$route.query.item.content;
        this.chooseNote = true;
      }
    }
  },
  mounted() {
    this.getArea();
    this.respondent = this.$route.query.toiletName + this.$route.query.toiletNum;
    this.wcNum = this.$route.query.toiletName + '(' + this.$route.query.toiletNum + ')';
    console.log(this.$route.query.wcId, 11);
  },
  methods: {
    // 返回上一页
    Back() {
      this.$router.go(-1);
    },
    InputBlur() { },
    showArea() {
      if (this.areaType) {
        this.areaType = false;
      } else {
        this.areaType = true;
        this.show = true;
        //this.getArea();
        //console.log(this.value);
      }
    },
    onSelect(item) {
      this.areaType = false;
      this.areaNote = true;
      this.name = item.name;
      this.value = item.value;
      // 默认情况下，点击选项时不会自动关闭菜单
      // 可以通过 close-on-click-action 属性开启自动关闭
      this.show = false;
      for (let i = 0; i < this.option1.length; i++) {
        if (item.name === this.option1[i].name) {
          this.option1[i].color = '#178357';
        } else {
          this.option1[i].color = '#333';
        }
      }
      // for (let i = 0; i < this.option1.length; i++) {
      //     if (item.name === this.option1[i].value) {
      //       this.optionTitle = this.option1[i].name
      //     }
      // }
    },
    clickOverlay() {
      this.areaType = false;
    },

    // open(){
    //   this.navdata = true
    //   this.showType = false;
    //   //document.querySelector('.van-dropdown-item--down').style.top = localStorage.getItem('mytop')+'px';
    // },
    // close(){
    //   this.navdata = false
    // },
    //
    // change(value) {
    //   this.navdata = false
    //   for (let i = 0; i < this.option1.length; i++) {
    //     if (value === this.option1[i].value) {
    //       this.optionTitle = this.option1[i].text
    //     }
    //   }
    // },

    //获取投诉人所在园区
    getArea() {
      if (
        sessionStorage.getItem('latitude') === null ||
        sessionStorage.getItem('longitude') === null
      ) {
        this.latitude = '1';
        this.longitude = '1';
      } else {
        this.latitude = sessionStorage.getItem('latitude');
        this.longitude = sessionStorage.getItem('longitude');
      }
      this.$request
        .get(`/appserver/v1/complaint/findGarden?range=${this.range}`, {
          headers: {
            latitude: this.latitude, //纬度
            longitude: this.longitude, //经度
          },
        })
        .then(data => {
          if (data.data.ret === 0) {
            for (let i = 0; i < data.data.data.scenicList.length; i++) {
              if (this.option1.length <= data.data.data.scenicList.length) {
                this.option1.push({
                  name: data.data.data.scenicList[i].scenic,
                  value: data.data.data.scenicList[i].poiId,
                });
              }
              if (this.$route.query.wcId == data.data.data.scenicList[i].scenicId) {
                this.areaNote = true;
                this.name = data.data.data.scenicList[i].scenic;
                this.value = data.data.data.scenicList[i].poiId;
                this.option1[i].color = '#178357';
              } else {
                this.option1[i].color = '#333';
                this.optionTitle = '请选择投诉事件发生地';
              }
            }
            // for (let i in data.data.data.scenicList) {
            //   var obj = data.data.data.scenicList[i];
            //   console.log(obj)
            //   for (var key in obj) {
            //     var newKey = "name";
            //     var newKey2 = "id";
            //     if (key == "text") {
            //       obj[newKey] = obj[key];
            //       delete obj[key];
            //     }
            //     if(key == "value"){
            //       obj[newKey2] = obj[key];
            //       delete obj[key];
            //     }
            //   }
            // }
            // console.log(this.option1);

            // for (let i = 0; i < data.data.data.scenicList.length; i++) {
            //   if (this.option1.length <= data.data.data.scenicList.length) {
            //     this.option1.push({
            //       text: data.data.data.scenicList[i].scenic,
            //       value: data.data.data.scenicList[i].scenicId
            //     })
            //   }
            //   if (this.$route.query.scenicId === data.data.data.scenicList[i].scenicId) {
            //     this.optionTitle = data.data.data.scenicList[i].scenic
            //     this.value = data.data.data.scenicList[i].scenicId
            //   } else {
            //     this.optionTitle = "请选择投诉事件发生地"
            //   }
            // }
          } else {
            this.$toast(data.data.msg);
          }
        });
    },

    //上传图片到服务器
    afterRead(file) {
      if (this.fileList.length > 10) {
        (this.picDisabled = true),
          this.$toast({
            message: '最多可上传10张图片',
            duration: '2000',
          });
        return false;
      }

      this.loadingImg = true;
      let params = [];
      if (Array.isArray(file) != true) {
        let newFile = [];
        newFile.push(file);
        file = newFile;
      }
      let n = 0;
      for (let i = 0; i < file.length; i++) {
        params.push(file[i].file);
        let fromData = new FormData();
        fromData.append('file', params[i]);
        this.$request
          .post('/appserver/v1/upload/image', fromData)
          .then(res => {
            if (res.data.ret == 0) {
              n = n + 1;
              this.gallerys.push(res.data.data.fileUrl);
              this.gallerysLength = this.gallerys.length;
              if (this.gallerysLength > 10) {
                this.gallerys.splice(10, this.gallerysLength - 10);
                this.$toast('图片最多可10张');
                this.loadingImg = false;
              }
              // console.log(n);
              if (n == file.length) {
                this.$toast('上传成功！');
                this.loadingImg = false;
              }
            } else {
              this.$toast(res.data.msg);
              this.loadingImg = false;
            }
          })
          .catch(err => {
            // eslint-disable-next-line
            console.log(err);
            this.$toast(err);
            this.loadingImg = false;
          });
      }
    },

    onDelete(data, i) {
      if (i.index !== -1) {
        this.fileList.splice(i.index, 1);
        if (this.fileList.length < 10) {
          this.picDisabled = false;
        }
        this.gallerys.splice(i.index, 1);
      }
    },
    //获取投诉类别
    getComplainttype() {
      this.$request.get(`/appserver/v1/complaint/complaintType`).then(data => {
        if (data.data.ret === 0) {
          for (let i in data.data.data) {
            var obj = data.data.data[i];
            for (var key in obj) {
              var newKey = 'children';
              var newKey2 = 'text';
              if (key == 'child') {
                obj[newKey] = obj[key];
                delete obj[key];
              } else if (key == 'prmValue') {
                obj[newKey2] = obj[key];
                delete obj[key];
              }
            }
            for (let j in data.data.data[i].children) {
              var obj2 = data.data.data[i].children[j];

              for (var key2 in obj2) {
                var newKey3 = 'text';
                var newKey4 = 'preprmKey';

                if (key2 == 'prmValue') {
                  obj2[newKey3] = obj2[key2];
                  delete obj2[key2];
                } else if (key2 == 'sortNum') {
                  obj2[newKey4] = data.data.data[i].prmKey;
                  delete obj2[key2];
                }
              }
            }
            this.items.push(obj);
          }
        }
      });
    },

    //点击展开投诉类别
    showChoose() {
      if (this.showType) {
        this.showType = false;
      } else {
        this.showType = true;
      }
    },

    //选则投诉类别
    onItemClick(data) {
      // this.choosetext = data.text;
      this.type = data.preprmKey;
      this.category = data.prmKey;
      this.activeId = data.id;
      this.showType = false;
      this.chooseNote = true;
    },

    //提交投诉
    onSubmit() {
      if (this.choosetext == '') {
        this.$toast('投诉类别不能为空!');
        return false;
      }
      if (this.value == '') {
        this.$toast('请选择投诉事件发生地!');
        return false;
      }
      if (this.respondent == '') {
        this.$toast('投诉对象不能为空!');
        return false;
      }
      if (this.complaintReson == '') {
        this.$toast('投诉原因不能为空!');
        return false;
      }
      if (this.fileList.length > 10) {
        this.$toast('最多可上传10张图片');
        return false;
      }

      this.loadingbutton = true;
      this.loadingtext = '加载中...';
      console.log(this.value, 22222);
      let data = {
        type: this.type, //投诉类别
        category: this.category, //投诉分类
        areaId: this.value, //投诉事件发生地
        complainant: this.complainant, //投诉人名称
        uid: this.$cookie.get('w_uid'),
        // uid: "1",//测试id
        respondent: this.wcNum, //投诉对象
        complaintReson: this.complaintReson, //投诉原因
        phone: this.phone,
        imgUrls: this.gallerys.toString(),
        channel: 3,
        wisdomNum: this.wcNum,
      };

      this.$request.post('/appserver/v1/complaint/submit', qs.stringify(data)).then(data => {
        if (data.data.ret == 0) {
          this.$toast('投诉成功');
          this.loadingbutton = false;
          this.loadingtext = '';
          //投诉成功跳转到投诉主页
          // this.$router.push({
          // 	path: '/complain'
          // });
          this.$router.go(-1);
        } else {
          console.log('投诉')
          Dialog.confirm({
            title: '投诉',
            message: data.data.msg,
            confirmButtonColor: '#2EBA73',
            showCancelButton: false,
          }).then(() => {
            if (data.errorcode == 2002) {  // 用户未登录
              this.wxAuth();
            } else if (data.errorcode == 2003) {  // 一天只能评论一次
              // this.$router.replace({
              //   path: '/wcDetail',
              //   query: {
              //     wc_id: this.$route.query.wc_id,
              //   },
              // });
              this.$router.go(-1);
            } else { // 评价失败
              this.$router.go(-1);
              // this.$router.replace({
              //   path: '/wcDetail',
              //   query: {
              //     wc_id: this.$route.query.wc_id,
              //   },
              // });
            }
          });
          // this.$toast(data.data.msg);
          this.loadingbutton = false;
          this.loadingtext = '';
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.nav_select {
  position: fixed;
  width: 100%;
  background: #fff;
}
.complain-submit {
  font-size: 14px;
  .title {
    .van-nav-bar__title {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
    }
    .van-nav-bar .van-icon {
      color: #4a4a4a;
      font-size: 22px;
      font-weight: 600;
    }
  }
  .content {
    padding-bottom: 120px;
    .van-cell-group {
      padding: 0 20px;
    }
    /deep/ .vant-field_body textarea,
    /deep/ .vant-field_body input {
      -webkit-user-select: auto;
    }
    /deep/ .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border: 0px;
    }
    .form-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      margin: 0 20px;
      border-bottom: 1px solid #e1e1e1;
      /deep/ .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border: 0px;
      }
      /deep/ .van-ellipsis {
        min-width: 156px;
      }
      .form-label {
        display: flex;
        align-items: center;
        width: 150px;
        font-size: 14px;
        span {
          font-size: 11px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: rgba(55, 56, 77, 1);
        }
      }
      .form-choose {
        flex: 1;
        display: flex;
        position: relative;
        color: #969799;
        .choosetype {
          line-height: 50px;
          display: flex;
          align-items: center;
          width: 100%;
          padding-left: 8px;
          i {
            position: absolute;
            right: 0;
          }
        }
      }
      /deep/.van-dropdown-menu__title {
        color: #969799;
      }
      .van-cell {
        line-height: 50px;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    .greenway {
    }
    .subbutton {
      width: 100%;
      padding: 0 20px;
      position: fixed;
      left: 0;
      bottom: 0;
      box-sizing: border-box;
      background: white;
      .submit {
        background: #2eba73;
        color: #fff;
        width: 100%;
        height: 40px;
        font-size: 15px;
        border-radius: 3px;
        margin-top: 50px;
        margin-bottom: 30px;
      }
    }

    .van-cell {
      padding-left: 0;
    }
    /deep/.van-field__label {
      width: 150px;
    }
    /deep/.van-cell__title {
      width: 150px;
    }
    /deep/.van-cell__value {
      padding-left: 8px;
    }
    .van-cell-group span {
      text-align: right;
      position: absolute;
      top: 14px;
      left: 79px;
      font-size: 11px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #37384d;
    }
    .up-img {
      border-top: 10px solid #f8f8f8;
      padding: 0 20px;
      padding-top: 20px;
      p {
        margin-bottom: 10px;
        span {
          font-size: 11px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #37384d;
        }
      }
    }
  }

  /deep/.van-sidebar-item--select {
    font-weight: normal;
  }
  /deep/.van-tree-select__item {
    font-weight: normal;
  }

  .fb-btn {
    position: relative;
    margin-top: 15px;
    .icon-img {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .icon-image {
        width: 20px;
        height: 20px;
      }
      .pic_delete {
        position: relative;
        .delImg {
          position: absolute;
          bottom: 5px;
          right: 10px;
          width: 15px;
          height: 15px;
        }
      }
    }

    /deep/ .van-loading {
      position: absolute;
      margin-top: 20px;
      left: 40%;
      top: 10%;
    }
  }
  .chooseNote {
    color: #333;
  }
  .form-item {
    /deep/.van-field__body {
      height: 50px;
    }
    /deep/.van-field__control {
      height: 30px;
      line-height: 30px;
    }
  }
  /deep/.van-popup--bottom {
    height: 250px;
  }
}
</style>
